import { CircularProgress, Stack } from '@mui/material';

function Loading() {
  return (
    <Stack
      mt={3}
      alignItems="center"
      justifyContent="center"
      height="100%"
      width="100%">
      <CircularProgress />
    </Stack>
  );
}

export default Loading;
